import React from "react";
import BlogHero from "@/components/Blogs/BlogPage/Hero";
import AllBlogs from "@/components/Blogs/BlogPage/Blogs";
import FreeAppraisal from "@/components/Common/FreeAppraisal";
import { createClient } from "../../../prismicio";
import Metadata from "@/components/Metadata";
import Layout from "@/components/Layout";

const Blogs = ({ page, globals }) => {
  let categoryTitle = [{ name: "All" }];
  let category = [];
  let blog = [];
  let mainImage;
  let mainTitle;
  let mainCategory;
  let mainDate;
  let mainText;
  let mainButtonLink;

  const commonComponents = globals?.data;

  {
    page?.map(({ data, uid, last_publication_date }, idx) => {
      var date = new Date(last_publication_date);
      var dateFormat =
        date.getDay() +
        " " +
        date.toLocaleString("default", { month: "long" }) +
        " " +
        date.getFullYear();

      if (data?.main_view) {
        mainImage = data?.image;
        mainTitle = data?.title;
        mainCategory = data?.category;
        mainDate = dateFormat;
        mainText = data?.excerpt;
        mainButtonLink = uid;
      }
      categoryTitle?.push({ name: data?.category });
      blog.push({
        image: data?.image,
        title: data?.title,
        categoryTitle: data?.category,
        date: dateFormat,
        text: data?.excerpt,
        buttonLink: uid,
        mainView: data?.main_view,
      });
      if (page?.length === idx + 1) {
        category = categoryTitle.filter(
          (ele, ind) =>
            ind === categoryTitle.findIndex((elem) => elem.name === ele.name),
        );
      }
    });
  }

  const withoutFeaturedBlog = blog.filter((blogItem) => !blogItem.mainView);

  const blogs = {
    category: category,
    blog: withoutFeaturedBlog,
  };

  const hero = {
    image: mainImage,
    title: mainTitle,
    categoryTitle: mainCategory,
    date: mainDate,
    text: mainText,
    buttonLink: mainButtonLink,
  };

  return (
    <Layout data={commonComponents}>
      <Metadata
        // title={page?.metadata_title}
        // description={page?.metadata_desc}
        // image={page?.metadata_image}
        title={"Resources"}
        description={""}
        image={""}
        path="/blogs"
      />
      <BlogHero data={hero} />
      <AllBlogs dataBlog={blogs} />
      <FreeAppraisal page={"Blogs"} />
      <div style={{ height: "40px" }}></div>
    </Layout>
  );
};

export default Blogs;

export async function getStaticProps({ previewData }) {
  const client = createClient({ previewData });

  const page = await client.getAllByType("blog_individual_page");
  const globals = await client.getSingle("globals");

  return {
    props: {
      page,
      globals,
    },
  };
}
